import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import setupInterceptors from "@/core/api/interceptor";
import VueSweetalert2 from "vue-sweetalert2";

const appInstance = createApp(App);

setupInterceptors(store);

appInstance.use(VueSweetalert2);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
